import React, { useContext } from 'react';

import { app, media } from 'context';
import { Layout, PillButton, Text } from 'ds';
import { SERVICES_REQUEST_PATH } from 'routes';

import { CODI_DEMO_YOUTUBE_URL } from './homeV10Constants';
import HeroSlackPanel from './HeroSlackPanel';

const HeroRedesign: React.FC = () => {
  const { isMobile, xs } = useContext(media);
  const { contentPaddingX } = useContext(app);

  return (
    <Layout
      color="blue-25"
      position="relative"
      overflow="hidden"
      paddingY={isMobile ? 48 : 80}
      paddingX={contentPaddingX}
    >
      <div className="HomeV10-hero">
        <div className="HomeV10-heroBg" aria-hidden />
        <div className="HomeV10-heroBg2" aria-hidden />
        <div className="HomeV10-heroPurpleGlow" aria-hidden />
      </div>
      <Layout position="relative" justify="center" flex>
        <Layout
          maxWidth={1280}
          flexGrow={1}
          __style={
            xs
              ? { display: 'flex', flexDirection: 'column', gap: 40 }
              : { display: 'grid', gridTemplateColumns: '1fr 1.1fr', gap: 56, alignItems: 'center' }
          }
        >
          <Layout className="HomeV10-heroText" direction="column" align="flex-start">
            <Text
              tag="h1"
              size="display-lg"
              color="gray-900"
              __style={{
                fontSize: 'clamp(44px, 5.2vw, 80px)',
                fontWeight: 800,
                lineHeight: 1.02,
                letterSpacing: '-0.035em',
                marginBottom: 28,
                marginTop: 0,
                whiteSpace: xs ? 'normal' : 'nowrap'
              }}
            >
              Your office will
              <br />
              <span className="HomeV10-heroAccent">run itself.</span>
            </Text>
            <Layout marginBottom={36} maxWidth={560}>
              <Text size="body-xl" color="gray-400" __style={{ lineHeight: 1.55, fontSize: 20, margin: 0 }}>
                Codi is the AI office assistant that takes the daily logistics off your plate and effectively operates
                your office.
              </Text>
            </Layout>
            <Layout flex gap={12} wrap align="center">
              <PillButton
                type="purpleGradient"
                size="lg"
                text="Get started"
                href={SERVICES_REQUEST_PATH}
                icon="rightArrow"
                iconPosition="right"
                hasShadow
              />
              <PillButton
                type="secondaryOutline"
                size="lg"
                text="See it in 60 seconds"
                href={CODI_DEMO_YOUTUBE_URL}
                icon="rightCaret"
                iconPosition="left"
              />
            </Layout>
          </Layout>
          <Layout direction="column" justify="center" align={xs ? 'stretch' : 'flex-end'} flex>
            <HeroSlackPanel />
          </Layout>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default HeroRedesign;
